
const categories = [
  {
    name: '緑茶',
    nameEn: 'Green Tea',
    description: '深蒸し煎茶や玉露など、旨味と甘みが際立つ日本の代表的なお茶',
    image: 'https://public.readdy.ai/ai/img_res/298382d01da26b8231bcdf4fd98f6413.jpg',
    color: '#7B8C3E',
  },
  {
    name: 'ほうじ茶',
    nameEn: 'Hojicha',
    description: '香ばしい焙煎香とまろやかな味わい。カフェイン控えめで夜にも最適',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20roasted%20hojicha%20tea%20in%20clear%20glass%20cup%20warm%20amber%20brown%20color%20on%20minimal%20ceramic%20saucer%20clean%20white%20background%20professional%20product%20photography%20warm%20lighting&width=400&height=500&seq=teacat002&orientation=portrait',
    color: '#A0724A',
  },
  {
    name: '和紅茶',
    nameEn: 'Japanese Black Tea',
    description: '日本の茶葉で作られた紅茶。渋みが少なく、優しい甘みが特徴',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20black%20tea%20wakocha%20in%20clear%20glass%20cup%20deep%20reddish%20amber%20color%20on%20minimal%20ceramic%20saucer%20clean%20white%20background%20professional%20product%20photography%20warm%20lighting&width=400&height=500&seq=teacat003&orientation=portrait',
    color: '#C4787A',
  },
  {
    name: '烏龍茶',
    nameEn: 'Oolong Tea',
    description: '半発酵の奥深い味わい。花のような香りと爽やかな後味',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20oolong%20tea%20in%20clear%20glass%20cup%20golden%20amber%20color%20on%20minimal%20ceramic%20saucer%20clean%20white%20background%20professional%20product%20photography%20warm%20lighting&width=400&height=500&seq=teacat004&orientation=portrait',
    color: '#C4A24A',
  },
];

export default function TeaCategories() {
  return (
    <section className="py-16 sm:py-24 md:py-32 bg-white" aria-labelledby="tea-categories-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <span className="inline-block px-3 py-1.5 bg-[#7B8C3E]/10 text-[#7B8C3E] text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
            CATEGORY
          </span>
          <h2 id="tea-categories-heading" className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-3 sm:mb-4 tracking-[0.1em]">
            お茶のカテゴリー
          </h2>
          <p className="text-sm sm:text-base text-black/60 font-extralight tracking-wide">
            厳選されたシングルオリジンの日本茶をティーバッグで
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" role="list">
          {categories.map((cat, index) => (
            <article
              key={index}
              className="group cursor-pointer"
              role="listitem"
            >
              <div className="relative aspect-[4/5] rounded-xl sm:rounded-2xl overflow-hidden mb-4 sm:mb-5 bg-gray-50">
                <img
                  src={cat.image}
                  alt={`${cat.name} - ${cat.nameEn}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  width="400"
                  height="500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="flex items-center gap-2 mb-2">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: cat.color }}></div>
                <span className="text-xs text-black/40 font-light tracking-[0.15em] uppercase">{cat.nameEn}</span>
              </div>
              <h3 className="text-lg sm:text-xl font-light text-black mb-1.5 tracking-wide">{cat.name}</h3>
              <p className="text-sm text-black/60 font-extralight leading-relaxed">{cat.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
